import { MessageCircle } from "lucide-react";

const WA = "https://wa.me/918287828387?text=Hello%20Indiora%20Journeys%2C%20I%27d%20like%20to%20plan%20a%20private%20journey.";

export default function WhatsAppFab() {
  return (
    <a
      href={WA}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-6 left-6 z-[60] group flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebe57] text-white pl-4 pr-5 py-3 shadow-[0_10px_30px_rgba(37,211,102,0.45)] transition-all duration-300 hover:-translate-y-0.5"
      style={{ borderRadius: "999px" }}
    >
      <span className="relative flex h-6 w-6 items-center justify-center">
        <span className="absolute inline-flex h-full w-full rounded-full bg-white/30 animate-ping" />
        <MessageCircle size={20} strokeWidth={2} className="relative" />
      </span>
      <span className="text-[12px] tracking-[0.18em] uppercase font-semibold whitespace-nowrap hidden sm:inline">
        Chat on WhatsApp
      </span>
    </a>
  );
}
